import { createContext, useContext } from 'react';
import { IPredicateContext } from './types';
import {
  IFieldFieldsFragment,
  ILogicalOperator,
} from '../../utils/apollo/graphqlSchema';
import { assertNotNil } from '../../utils/types';

// To avoid prop drilling, we will pass FilterWidget props to its children
// via React context
export interface IFilterWidgetPropValues {
  schemaId: string;
  context: IPredicateContext;
  defaultLogOps: ILogicalOperator[];
  lockedField?: IFieldFieldsFragment; // there is only one field to work with
  disableNamedFilters?: boolean;
  includeAnyValue?: boolean; // includes the value "Any" in the predicate operands, only used in dashboard filter
}

export const FilterWidgetPropContext =
  createContext<IFilterWidgetPropValues | null>(null);

export const useFilterWidgetPropContext = () => {
  const contextValue = useContext(FilterWidgetPropContext);
  assertNotNil(contextValue);
  return contextValue;
};
